import { StyledBadge } from "./Badge.styles";
import { BadgeProps } from "../../../interfaces";

export const Badge = ({ variant = "neutral", children }: BadgeProps) => {
  return <StyledBadge $variant={variant}>{children}</StyledBadge>;
};
